import { supabase } from "../supabase/SupabaseClient";

/* El pañol: los envíos con sus usos adentro.
 *
 * ── ESTA PANTALLA ES DE MIRAR, CON UNA EXCEPCIÓN ──────────────────────────
 *
 * Se despacha, se recibe y se usa **por WhatsApp**: el que pone la caja en el
 * camión está en el pañol de Buenos Aires y el que la recibe está en el
 * puerto, ninguno de los dos con una pantalla adelante. Duplicar la carga acá
 * obligaría a adivinar en cuál de los dos lados se anota — es la lección de
 * los dos talleres.
 *
 * Lo único que se escribe desde acá es **anular**, y es al revés que todo lo
 * demás a propósito: es lo único que saca un envío de la lista de lo que falta
 * recibir, o sea lo único que borra algo del control. Por WhatsApp se escribe
 * apurado y con una mano; acá está la fila entera a la vista y queda con quién
 * la anuló. Mismo criterio que el borrado de tickets.
 *
 * ── Y ANULAR NO ES BORRAR ─────────────────────────────────────────────────
 *
 * La fila queda. Que alguien haya decidido que ese envío no va es parte de la
 * historia — hacerlo desaparecer deja el control sin poder explicar el hueco.
 */

/* Los envíos, lo más nuevo primero, con sus usos anidados.
 *
 * Los anulados NO se piden: la pantalla que se mira todos los días es la de lo
 * que vale. La fila sigue en la base.
 */
export async function envios(limite = 300) {
  const { data, error } = await supabase
    .from("panol_envios")
    .select("*, usos:panol_usos(*)")
    .is("anulado_en", null)
    .order("despachado_en", { ascending: false })
    .limit(limite);
  if (error) throw error;
  return data || [];
}

/* Anular un envío mal cargado. Queda con QUIÉN lo anuló: es la pregunta que
 * aparece el día que alguien busca un envío que despachó y no está. */
export async function anularEnvio(id, mail) {
  const { error } = await supabase
    .from("panol_envios")
    .update({ anulado_en: new Date().toISOString(), anulado_por: mail || null })
    .eq("id", id);
  if (error) throw error;
}

/* Anular un USO, que es otra cosa que anular el envío.
 *
 * Anular el uso devuelve el saldo al envío —se anotó de más, o en la unidad
 * equivocada— y el envío sigue existiendo. Fundir las dos acciones haría que
 * corregir «lo puse en el 774 y era el 812» borre el envío entero.
 */
export async function anularUso(id, mail) {
  const { error } = await supabase
    .from("panol_usos")
    .update({ anulado_en: new Date().toISOString(), anulado_por: mail || null })
    .eq("id", id);
  if (error) throw error;
}
